import LayoutContainerBubbles from './LayoutContainerBubbles';
import BotBubble from './BotBubble';
import BubbleActions from './BubbleActions';

import UserBubble from './UserBubble';

import { Message, ProductName } from '@/types/discover';

interface BubbleContainerProps {
  data: Message;
  messages: Message[];
  setMessages: React.Dispatch<React.SetStateAction<Message[]>>;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  productNameList: Array<ProductName>;
  isLatest: boolean;
  actionType?: 'default' | 'feedback' | 'none';
  isDashboard?: boolean;
  isGradient?: boolean;
}

const BubbleContainer = ({
  data,
  isDashboard = false,
  setMessages,
  setIsLoading,
  productNameList,
  isLatest,
  actionType = 'none',
  isGradient = false,
}: BubbleContainerProps) => {
  return (
    <LayoutContainerBubbles data={data}>
      {data.sender === 'bot' ? (
        <div className="flex w-full flex-col gap-[8px]">
          <BotBubble
            isDashboard={isDashboard}
            type="headerBubble"
            text={data.text}
            isGradient={isGradient}
          />
          {actionType === 'default' && (
            <BubbleActions
              data={data}
              setMessages={setMessages}
              setIsLoading={setIsLoading}
              productNameList={productNameList}
              isLatest={isLatest}
            />
          )}
        </div>
      ) : (
        <UserBubble data={data} isDashboard={isDashboard} isAlert={data.sender === 'alert'} />
      )}
    </LayoutContainerBubbles>
  );
};

export default BubbleContainer;
